export const dgorderRoutes = [
  {
    path: '/dgorder/create',
    name: 'DgorderCreate',
    component: () => import(/* webpackChunkName: "dgorder" */'@/views/dgorder/create/Create.vue'),
    meta: {
      title: '1688代購'
    }
  },
  {
    path: '/dgorder/detail/:id',
    name: 'DgorderDetail',
    component: () => import(/* webpackChunkName: "dgorder" */'@/views/dgorder/detail/Detail.vue'),
    meta: {
      title: '1688代購訂單詳情'
    }
  },
  {
    path: '/dgorder/detail-print',
    name: 'DgorderDetailPrint',
    component: () => import(/* webpackChunkName: "dgorder" */'@/views/dgorder/detail/Print.vue'),
    meta: {
      title: '列印訂單詳情'
    }
  },
  {
    path: '/dgorder/list',
    name: 'DgorderList',
    component: () => import(/* webpackChunkName: "dgorder" */'@/views/dgorder/List/List.vue'),
    meta: {
      title: '1688代購訂單列表'
    }
  },
  {
    path: '/dgorder/offer/:id',
    name: 'DgorderOffer',
    component: () => import(/* webpackChunkName: "dgorder" */'@/views/dgorder/offer/Offer.vue'),
    meta: {
      title: '1688商品詳情'
    }
  },
  {
    path: '/dgorder/cart',
    name: 'DgorderCart',
    component: () => import('@/views/dgorder/cart/Cart.vue'),
    meta: {
      title: '採購車'
    }
  },
  {
    path: '/dgorder/createPreview',
    name: 'DgorderCreatePreview',
    component: () => import('@/views/dgorder/createPreview/CreatePreview.vue'),
    meta: {
      title: '確認訂單'
    }
  },
  {
    path: '/dgorder/repurchase/:id',
    name: 'DgorderRepurchase',
    component: () => import('@/views/dgorder/repurchase/Repurchase.vue'),
    meta: {
      title: '再次購買'
    }
  },
  {
    path: '/dgorder/rating/create/:id',
    name: 'DgorderRatingCreate',
    component: () => import('@/views/dgorder/rating/Create.vue'),
    meta: {
      title: '寫評價'
    }
  },
  {
    path: '/dgorder/rating/view/:id',
    name: 'DgorderRatingView',
    component: () => import('@/views/dgorder/rating/View.vue'),
    meta: {
      title: '查看評價'
    }
  },
  {
    path: '/dgorder/favorite',
    name: 'DgorderFavorite',
    component: () => import('@/views/dgorder/Favorite/List.vue'),
    meta: {
      title: '收藏列表'
    }
  },
  {
    path: '/dgorder/cart/import1688Cart',
    name: 'DgorderCartImport1688Cart',
    component: () => import('@/views/dgorder/cart/Import1688Cart/Import1688Cart.vue'),
    meta: {
      title: '導入1688購物車'
    }
  },
  {
    path: '/dgorder/afterSale/detail',
    name: 'DgorderAfterSaleDetail',
    component: () => import(/* webpackChunkName: "dgorder" */'@/views/dgorder/afterSale/Detail.vue'),
    meta: {
      title: '售後詳情'
    }
  },
]
